module.exports = __webpack_public_path__ + "img/18Ox15O.d41d8cd9.svg";